'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.setRightBoxHeight = setRightBoxHeight;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _DispatchWarning = require('../components/DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _SendOrderButton = require('./SendOrderButton');

var _SendOrderButton2 = _interopRequireDefault(_SendOrderButton);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartSummary = function (_Component) {
    (0, _inherits3.default)(CartSummary, _Component);

    function CartSummary() {
        (0, _classCallCheck3.default)(this, CartSummary);
        return (0, _possibleConstructorReturn3.default)(this, (CartSummary.__proto__ || (0, _getPrototypeOf2.default)(CartSummary)).apply(this, arguments));
    }

    (0, _createClass3.default)(CartSummary, [{
        key: 'render',
        value: function render() {
            var _props$cart = this.props.cart,
                totalVat = _props$cart.totalVat,
                _props$cart$totalPric = _props$cart.totalPrice,
                totalPrice = _props$cart$totalPric === undefined ? {} : _props$cart$totalPric;


            return _react2.default.createElement(
                'div',
                { className: 'contentBox' },
                _react2.default.createElement(
                    'div',
                    { className: 'w100 costDetails' },
                    _react2.default.createElement(
                        'div',
                        { className: 'table-block', id: 'order-detail-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'w100 cartMiniTable' },
                            _react2.default.createElement(
                                'div',
                                { className: 'clearfix row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-6 col-lg-12' },
                                    _react2.default.createElement(
                                        'table',
                                        { id: 'cart-summary', className: 'std table' },
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                { className: 'cart-total-price ' },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _localize2.default)("App:TotalPriceWithoutVat")
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'price' },
                                                    (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPriceWithoutVat)
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _localize2.default)("App:TotalVat")
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'price', id: 'total-tax' },
                                                    (0, _linksoftAlbatros.formatPrice)(totalVat, _linksoftAlbatros.PriceType.CartTotalPriceVat)
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _localize2.default)("App:TotalPriceWithVat")
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'site-color',
                                                        id: 'total-price' },
                                                    (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'table-sumary-info col-sm-6 col-lg-12' },
                                    _react2.default.createElement(_DispatchWarning2.default, null)
                                )
                            )
                        ),
                        _react2.default.createElement(_SendOrderButton2.default, null)
                    )
                )
            );
        }
    }]);
    return CartSummary;
}(_react.Component);

CartSummary.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    saveOptions: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        cart: state.cart
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    saveOptions: _actions2.default.saveOptions
})(CartSummary);
function setRightBoxHeight() {
    setTimeout(function () {
        if (!window.matchMedia("(min-width: 1200px)").matches) return;
        // abp.log.debug('setRightBoxHeight');

        var $contentBox = (0, _jquery2.default)('.contentBox');
        var $rightSidebar = (0, _jquery2.default)('.rightSidebar');
        var stickyParam = {
            parent: $rightSidebar,
            offset_top: 70 // need this offset because main nav is fixed too
        };
        var contentBoxHeight = $contentBox.height(),
            parentHeight = $rightSidebar.prev().height();

        if (contentBoxHeight < parentHeight) {
            $rightSidebar.css('height', parentHeight - 5); // 5px less because stupid table height
        } else {
            $rightSidebar.attr('style', '');
        }

        $contentBox.trigger('sticky_kit:recalc').stick_in_parent(stickyParam);

        (0, _jquery2.default)('.nav-tabs a').on('click', function () {
            setTimeout(function () {
                if ((0, _jquery2.default)('#notAvailable').hasClass('active')) {
                    $contentBox.trigger('sticky_kit:detach');
                } else {
                    $contentBox.trigger('sticky_kit:recalc').stick_in_parent(stickyParam);
                }
            }, 100);
        });
    }, 800);
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartSummary.js
// module id = 900
// module chunks = 0